import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { MainPageComponent } from '../components/main-page/main-page.component';
import { PrivacyComponent } from './privacy.component';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy.page.html',
  styleUrls: ['./privacy.page.scss'],
  imports: [
    AppCommonModule,
    CommonModule, MainPageComponent,
    PrivacyComponent,
  ],
})
export class PrivacyPage {

}
